/**
 * Handle notifications from backend using pusher
 */
import AppGlobals from "./AppGlobals";
import TTLProxy from "./TTLAsyncProxy";
import {createClient} from "./RealtimeNotificationClient";
import _ from 'lodash';

class NotificationHandler {

    //  Application ID
    appId = process.env.REACT_APP_RNS_APP_ID;

    //  RNS Server Address
    serverAddress = process.env.REACT_APP_RNS_SERVER;

    //  RNS Server Path
    path = process.env.REACT_APP_RNS_SERVER_PATH;

    //  Socket ID Header
    _header_name = 'x-realtime-client-id';

    // Connection client
    client = null;

    //  The connection id for the client
    _connectionId;

    constructor(options){

        options = options || {};
        const authInfo = TTLProxy.getInstance().getAuthInfo();

        if(!authInfo){
            console.warn('Cannot start notification handler. User not authenticated');
            return;
        }

        this.client = createClient(this.serverAddress,{
            appId: this.appId,
            authToken: authInfo.token,
            path: this.path
        }, (client) => {

            //  get client connection id
            this._connectionId =  client.getConnectionId();

            //  trace to console
            if(process.env.NODE_ENV !== 'production'){
                console.log("Connected to realtime notification service =>" + this._connectionId);
            }

            //  call connected callback
            if(_.isFunction(options.connected)){
                options.connected();
            }

        });

    }

    /**
     *
     * @param {Object} initOptions Initialization options
     */
    static getInstance(initOptions = null){
        return AppGlobals.get('notifications', () => new NotificationHandler(initOptions) );
    }

    subscribeChannelEvent(channel, event,tag,cb){
        return this.client.subscribe(channel,event,cb);
    }

    disconnect(){
        this.client.close();
    }


}

export  default NotificationHandler;





// WEBPACK FOOTER //
// ./src/common/NotificationHandler.js